import axios from "axios";
import { subID } from "./Urls";

const apiClient = axios.create({
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

 function makeApiRequest(
  url,
  jsonBody,
  authKey,
  onResponse,
  onError
) {
  apiClient
    .post(url, jsonBody ?? {}, {
      headers: {
        Authkey: authKey,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
     // console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


 function callApi(
  url,
  jsonBody,
  authKey,
  onResponse,
  onError
) {
 // console.log("authkey api", authKey);

  apiClient
    .post(url, jsonBody ?? {}, {
      headers: {
        Authorization: authKey,
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
    //  console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


async function sendLandPandaNotification(payload) {
  const url = "https://unichat.erpthemes.com/landpanda/sendLandPandaNotification";

 

  try {
    const res = await axios.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("Success:", res.data);
    return res.data;
  } catch (err) {
    console.error("Error:", err.response?.data || err.message);
    throw err;
  }
}

 async function callAzureOpenAI(userInput) {
  const endpoint =
    "https://dialerpopenaiv1.openai.azure.com/openai/deployments/ChatBot-4o-mini/chat/completions?api-version=2024-02-15-preview";

  const apiKey = "CXwNASrbLo5ugztusWXBRfjDvald91B6PIakKCy9BaDZ7LrlVDhzJQQJ99BKACYeBjFXJ3w3AAABACOGXAsd"; // move to env in real apps

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": apiKey
      },
      body: JSON.stringify({
        messages: [
          {
            role: "user",
            content: userInput
          }
        ],
        max_tokens: 300,
        temperature: 0.7
      })
    });

    if (!response.ok) {
      const err = await response.text();
      throw new Error(err);
    }

    const data = await response.json();

    // ✅ Return ONLY the AI text
    return data.choices?.[0]?.message?.content ?? "";
  } catch (error) {
    console.error("Azure OpenAI Error:", error);
    return "Something went wrong. Please try again.";
  }
}


 function makeApiRequest_seperateDb(
  url,
  
  onResponse,
  onError
) {
  apiClient
    .get(url, {
      headers: {
        Authkey: "",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
     // console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


 function makeApiRequest_seperateDb_get(
  url,
  jsonBody,
  
  onResponse,
  onError
) {
  apiClient
    .get(url, jsonBody ?? {}, {
      headers: {
        Authkey: "",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
     // console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


export { makeApiRequest, callApi,sendLandPandaNotification,callAzureOpenAI,makeApiRequest_seperateDb,makeApiRequest_seperateDb_get };